import { render } from "./FlaggedPassesOld.vue?vue&type=template&id=313ef112"
import script from "./FlaggedPassesOld.vue?vue&type=script&lang=js"
export * from "./FlaggedPassesOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__